var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0823 2.24348C11.4484 1.87736 11.4484 1.28377 11.0823 0.917654C10.7162 0.551537 10.1226 0.551537 9.75649 0.917654L5.99999 4.67415L2.24349 0.917654C1.87737 0.551538 1.28378 0.551538 0.917665 0.917654C0.551549 1.28377 0.551549 1.87736 0.917665 2.24348L4.67416 5.99998L0.917654 9.75649C0.551538 10.1226 0.551537 10.7162 0.917654 11.0823C1.28377 11.4484 1.87736 11.4484 2.24348 11.0823L5.99999 7.3258L9.7565 11.0823C10.1226 11.4484 10.7162 11.4484 11.0823 11.0823C11.4484 10.7162 11.4484 10.1226 11.0823 9.75649L7.32581 5.99998L11.0823 2.24348Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimes);
export default __webpack_public_path__ + "static/media/times.e2add133bf2a8822a502c7558dce94ad.svg";
export { ForwardRef as ReactComponent };